import React from 'react'
import { Input } from '../../../../shared/ui/controls/Input/Input'
import { FieldWrapper } from '../../../../shared/ui'
import { FilterBar } from '../../../../shared/ui/layouts/FilterBar'
import { MultiSelectDropdown } from '../../../../shared/ui/controls/MultiSelectDropdown'
import { GewerkSearchSelect } from 'src/entities/gewerk'
import { HandwerkerSearchSelect } from 'src/entities/user'
import {
  useArbeitszeitReportFiltersParams,
  toArbeitszeitReportFiltersForm,
  ArbeitszeitReportFiltersForm,
} from '../../../../features/arbeitszeit-report/filters'
import { SCHEDULE_STATUS_OPTIONS, DEVIATION_STATUS_OPTIONS } from '../model/constants'
import type { ScheduleStatus, DeviationStatus } from '../../../../features/arbeitszeit-report/filters'

export const ArbeitszeitReportFilterBar: React.FC = () => {
  const [params, setParams] = useArbeitszeitReportFiltersParams()
  const filters = toArbeitszeitReportFiltersForm(params)

  const set = (patch: Partial<ArbeitszeitReportFiltersForm>) =>
    void setParams({ ...filters, ...patch })

  return (
    <FilterBar minColWidth="160px" gap={12} rowGap={8} >
      <FieldWrapper label="Zeitraum" className="col-span-2">
        <div className="flex gap-1 items-center w-full">
          <Input
            as="input"
            type="date"
            value={filters.dateFrom}
            onChange={(v) => set({ dateFrom: v })}
            placeholder=""
            className="flex-1 min-w-0"
          />
          <span className="shrink-0">-</span>
          <Input
            as="input"
            type="date"
            value={filters.dateTo}
            onChange={(v) => set({ dateTo: v })}
            placeholder=""
            className="flex-1 min-w-0"
          />
        </div>
      </FieldWrapper>

      <FieldWrapper label="Terminstatus">
        <MultiSelectDropdown<ScheduleStatus>
          value={filters.scheduleStatus}
          onChange={(v) => set({ scheduleStatus: v })}
          options={SCHEDULE_STATUS_OPTIONS}
          placeholder="Alle"
        />
      </FieldWrapper>

      <FieldWrapper label="Soll-Ist-Status">
        <MultiSelectDropdown<DeviationStatus>
          value={filters.deviationStatus}
          onChange={(v) => set({ deviationStatus: v })}
          options={DEVIATION_STATUS_OPTIONS}
          placeholder="Alle"
        />
      </FieldWrapper>

      <FieldWrapper label="Handwerker">
        <HandwerkerSearchSelect
          value={filters.technicianId ? Number(filters.technicianId) : null}
          onChange={(id) =>
            void setParams({ ...filters, technicianId: id == null ? '' : String(id) })
          }
        />
      </FieldWrapper>

      <FieldWrapper label="Gewerk">
        <GewerkSearchSelect
          value={filters.tradeId ? Number(filters.tradeId) : null}
          onChange={(id) =>
            void setParams({ ...filters, tradeId: id == null ? '' : String(id) })
          }
        />
      </FieldWrapper>
    </FilterBar>
  )
}
